import React from "react";
import { BodyAsFormData } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import Table from "react-bootstrap/Table";
import InfiniteScroll from "react-infinite-scroll-component";
import * as moment from "moment";
import { encodedUrlBuliding } from "../../../services/utilities/util";
import { Link } from "react-router-dom";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
const { Column, HeaderCell, Cell } = Table;
class recentNews extends React.Component {
  static contextType = FilterContext;

  state = {
    filters: "",
    showLoader: false,
    showGraph: false,
    data: [],
    loading: false,
    tableHeight: 400,
    bodyParams: "",
    page: 1,
    newsLoading: false,
    hasMore: false,
  };

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    this.setState({});
    var body = new FormData();
    body.append("filter", filters);
    body.append("section", "dashboard");
    body.append("page", 1);
    apiMiddleware.post("api/edge/office/get_recent_news", body).then((res) => {
      this.setState({ data: res.data, newsLoading: false }, () => {});
    });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters){
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });
      var body = new FormData();
      body.append("filter", JSON.stringify(this.props.filters));
      body.append("section", "asset");
      body.append("page", this.state.page);
      apiMiddleware
        .post("api/edge/office/get_recent_news", body)
        .then((res) => {
          this.setState({ data: res.data, newsLoading: false }, () => {});
        });
    }
  }

  fetchMoreData = () => {
    this.setState({ hasMore: true });
    var page = this.state.page + 1;
    this.setState({ page: page });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    var body = new FormData();
    body.append("filter", filters);
    body.append("section", "dashboard");
    body.append("page", page);
    apiMiddleware.post("api/edge/office/get_recent_news", body).then((res) => {
      var _data = [...this.state.data, ...res.data];
      this.setState({
        data: _data,
        hasMore: false,
      });
    });
  };

  handleScroll = (x, y) => {
    console.log(x, y);
    if (this.state.data.length > 0) {
      const contextHeight = this.state.data.length * 46;
      console.log(contextHeight);
      const top = Math.abs(y);
      console.log(top);
      console.log(this.state.tableHeight);
      if (
        contextHeight - top - this.state.tableHeight < 300 &&
        this.state.newsLoading == false
      ) {
        this.setState({ newsLoading: true });
        console.log("api call");
        this.loadMore();
      }
    }
  };

  getComplexNames(x) {
    let a = x.split(",");
    return a.map((name) => (
      <Link target="_blank" to={encodedUrlBuliding("complex", name)}>
        {name}
      </Link>
    ));
  }

  render() {
    return (
      <div className="widget widgetTable">
        <div className="row">
          <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
            <p>Recent News</p>
          </div>
          {this.state.data.length > 0 && (
            <div className="col-lg-12 mt-2">
              <InfiniteScroll
                dataLength={this.state.data.length}
                next={this.fetchMoreData}
                hasMore={this.state.data.length ? true : false}
                height={200}
                endMessage={
                  <p style={{ textAlign: "center" }}>
                    <b>Yay! You have seen it all</b>
                  </p>
                }
              >
                <Table
                  striped
                  bordered
                  style={{ width: "100%", height: "200px" }}
                  className="newsTable"
                >
                  <thead>
                    <tr>
                      <th>News Heading</th>
                      <th>Segment</th>
                      <th>Assets in News</th>
                      <th>Source</th>
                      <th>Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.data.map((item, index) => (
                      <tr style={{ height: "60px" }}>
                        <td>
                          <a href={item.link} target="_blank">
                            {item.title}
                          </a>
                        </td>
                        <td>{item.segment}</td>
                        <td>{this.getComplexNames(item.complex_names)}</td>
                        <td>{item.source}</td>
                        <td>{moment(item.timestamp).format("Do MMM YYYY")}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </InfiniteScroll>
            </div>
          )}
          {this.state.data.length == 0 && (
            <h6 className="mt-3">No Data Found</h6>
          )}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(recentNews);
